
import Admin_layout from "./admin/admin_layout";
import { Dashboard } from "./admin/pages";
import SignIn from "./admin/components/loginpage";
import { LoginNew } from "./adminlog/Login/LoginNew";
import Error404 from "./Compoents/Error404";
import { FAQ } from "./Pages/Aboutus/FAQ/FAQ";
import { HowWeWork } from "./Pages/Aboutus/HowWeWork/HowWeWork";
import { SqureMedTech } from "./Pages/Aboutus/SqureMed/SqureMedTech";
import { TherapeuticSpecialties } from "./Pages/Aboutus/Therapeutic/TherapeuticSpecialties";
import BlogForm from "./Pages/blog/BlogForm";
import BlogReport from "./Pages/blog/BlogReport";
import CategoryManagement from "./Pages/blog/CategoryManagement";
import Contact from "./Pages/Contact/Contact";
import Home from "./Pages/Home/home";
import BlogList from "./Pages/blog/BlogList";
import Blogs from "./Pages/blog/Blogs";
import BlogDetails from "./Pages/blog/BlogsDetails";
import Regulations from "./Pages/Resources/Regulations";
import RegulationsDetails from "./Pages/Resources/RegulationsDetails";
import AcronymsAbbreviations from "./Pages/Resources/AcronymsAbbreviations";
import AcronymsAbbreviationsDetails from "./Pages/Resources/AcronymsAbbreviationsDetails";
import Training from "./Pages/Resources/Training";
import TrainingDetails from "./Pages/Resources/TrainingDetails";
import { PharmaceuticalDetails } from "./Pages/Solutions/PharmaceuticalDetails";
import { HealthcareDetails } from "./Pages/Solutions/HealthcareDetails";
import { MedicalDevice } from "./Pages/Solutions/MedicalDevice";
import { DigitalHealthSolutions } from "./Pages/Solutions/MedicalDevicelist/DigitalHealthSolutions";
import { NotifyBodyA } from "./Pages/Solutions/MedicalDevicelist/NotifyBodayA";
import { NotifyBodyB } from "./Pages/Solutions/MedicalDevicelist/NotifyBodayB";
import { NotifyBodyC } from "./Pages/Solutions/MedicalDevicelist/NotifyBodayC";
import { TechnicalDocument } from "./Pages/Solutions/MedicalDevicelist/TechnicalDocument";
import { NotifyBodayBtwo } from "./Pages/Solutions/MedicalDevicelist/NotifyBodayBtwo";
import { NotifyBodayCone } from "./Pages/Solutions/MedicalDevicelist/NotifyBodayCone";
import { NotifyBodayCtwo } from "./Pages/Solutions/MedicalDevicelist/NotifyBodayCtwo";
import { NotifyBodayCthree } from "./Pages/Solutions/MedicalDevicelist/NotifyBodayCthree";
import { TechnicalDocumentA } from "./Pages/Solutions/MedicalDevicelist/TechnicalDocumentA";
import { TechnicalDocumentB } from "./Pages/Solutions/MedicalDevicelist/TechnicalDocumentB";
import { TechnicalDocumentC } from "./Pages/Solutions/MedicalDevicelist/TechnicalDocumentC";
import { QulityManagement } from "./Pages/ProductService/MedicalDevice/QulityManagement";
import { TechnicalDocumentation } from "./Pages/ProductService/MedicalDevice/TechnicalDocument";
import { PostMarket } from "./Pages/ProductService/MedicalDevice/PostMarket";
import { QualityAssurance } from "./Pages/ProductService/MedicalDevice/QualityAssurance";
import { ProductRegistrationService } from "./Pages/ProductService/MedicalDevice/ProductRegistrations";
import { DigitalHealthServicesProduct } from "./Pages/ProductService/MedicalDevice/DigitalHealthServices";
import { DataProtection } from "./Pages/ProductService/MedicalDevice/DataProtection";
import { RegulatoryLifeCycle } from "./Pages/ProductService/MedicalDevice/RegulatoryLifeCycle";
import { NMPAConsulting } from "./Pages/ProductService/HealthCare/NMPAConsulting";
import { HealthcareSurvey } from "./Pages/ProductService/HealthCare/HealthcareSurvey";
import { ClinicalInvestigation } from "./Pages/ProductService/CRO/ClinicalInvestigation";
import { ClinicalEvaluation } from "./Pages/ProductService/CRO/ClinicalEvaluation";
import { PMCFSolution } from "./Pages/ProductService/CRO/PMCFSolution";
import { MedicalTourism } from "./Pages/Solutions/MedicalTourism";
import { MedicalTourismDetails } from "./Pages/ProductService/MedicalTourism/MedicalTourismDetails";
import { Medtrust } from "./Pages/Medtrust/Medtrust";
import Treatment from "./Pages/Medtrust/Treatment";
import PatientStories from "./Pages/Medtrust/PatientStories";
import OurHospital from "./Pages/Medtrust/OurHospital";
import JinshazouHospital from "./Pages/HospitalsDetails/JinshazhouHospital";

const Routes =[
    {
        path:"/",
        element:<Home/>,
    },
    {
        path:"/contact-us",
        element:<Contact/>,
    },

    {
        path:"/blog-report",
        element:<BlogReport/>,
    },
    {
        path:"/category",
        element:<CategoryManagement/>,
    },
    {
        path:"/blogform",
        element:<BlogForm/>,
    },
    {
        path:"/square-medtech",
        element:<SqureMedTech/>,
    },
    {
        path:"/therapeutic-specialties",
        element:<TherapeuticSpecialties/>,
    },
    {
        path:"/how-we-work",
        element:<HowWeWork/>,
    },
    {
        path:"/faq",
        element:<FAQ/>,
    },
    {
        path:"/blog",
        element:<Blogs/>,
    },
    {
        path:"/BlogDetails/:id",
        element:<BlogDetails/>,
    },
    {
        path:"/regulations",
        element:<Regulations/>,
    },
    {
        path:"/regulations-details/:id",
        element:<RegulationsDetails/>,
    },
    {
        path:"/acronyms-abbreviations",
        element:<AcronymsAbbreviations/>,
    },
    {
        path:"/acronyms-abbreviations-details/:id",
        element:<AcronymsAbbreviationsDetails/>,
    },
    {
        path:"/training",
        element:<Training/>,
    },
    {
        path:"/pharmaceutical-details",
        element:<PharmaceuticalDetails/>,
    },
    {
        path:"/healthcare-details",
        element:<HealthcareDetails/>,
    },
     {
        path:"/medical-tourism",
        element:<MedicalTourism/>,
    },
         {
        path:"/medical-tourism-details",
        element:<MedicalTourismDetails/>,
    },
    {
        path:"/digital-health-solutions",
        element:<DigitalHealthSolutions/>,
    },
    {
        path:"/notified-body-transition-QMS-improvement",
        element:<NotifyBodyA/>,
    },
    {
        path:"/notified-body-transition-medical-writing",
        element:<NotifyBodyB/>,
    },
    {
        path:"/notified-body-transition-medical-clinical",
        element:<NotifyBodayBtwo/>,
    },
    {
        path:"/notified-body-transition-device-registration",
        element:<NotifyBodyC/>,
    },
    {
        path:"/notified-body-transition-device-registration-fda",
        element:<NotifyBodayCone/>,
    },
    {
        path:"/notified-body-transition-device-registration-nmpa",
        element:<NotifyBodayCtwo/>,
    },
    {
        path:"/notified-body-transition-device-registration-roa",
        element:<NotifyBodayCthree/>,
    },
    {
        path:"/technical-document-update",
        element:<TechnicalDocument/>,
    },
    {
        path:"/technical-document-update-united-states",
        element:<TechnicalDocumentA/>,
    },
    {
        path:"/technical-document-update-china",
        element:<TechnicalDocumentB/>,
    },
    {
        path:"/technical-document-update-other",
        element:<TechnicalDocumentC/>,
    },
    {
        path:"/medical-device-manufacturers",
        element:<MedicalDevice/>,
    },
    {
        path:"/training-details/:id",
        element:<TrainingDetails/>,
    },
    {
        path:"/qulity-management",
        element:<QulityManagement/>,
    },
    {
        path:"/technical-documentation-service",
        element:<TechnicalDocumentation/>,
    },
    {
        path:"/post-market",
        element:<PostMarket/>,
    },
    {
        path:"/quality-assurance",
        element:<QualityAssurance/>,
    },
    {
        path:"/product-registration-service",
        element:<ProductRegistrationService/>,
    },
    {
        path:"/digital-health-services",
        element:<DigitalHealthServicesProduct/>,
    },
    {
        path:"/data-protection",
        element:<DataProtection/>,
    },
    {
        path:"/regulatory-life-cycle",
        element:<RegulatoryLifeCycle/>,
    },
    {
        path:"/nmpa-consulting",
        element:<NMPAConsulting/>,
    },
    {
        path:"/healthcare-survey",
        element:<HealthcareSurvey/>,
    },
    {
        path:"/clinical-evaluation",
        element:<ClinicalEvaluation/>,
    },
    {
        path:"/clinical-investigation",
        element:<ClinicalInvestigation/>,
    },
    {
        path: "/medtrust-home",
        element:<Medtrust />

    },
    {
        path: "/medtrust-treatment",
        element: <Treatment />

    },
    {
        path: "/medtrust-patient",
        element: <PatientStories />

    },
    {
        path: "/medtrust-hospital",
        element: <OurHospital />

    },
    {
        path: '/jinshazhou-hospital',
        element: <JinshazouHospital />

    },
    {
        path:"/pmcf-solution",
        element:<PMCFSolution/>,
    },
    {
        path:"/service",
        element:<MedicalDevice/>,
    },
    {
        path:"/login",
        element:<LoginNew/>,
    },
    {
        path:"/signin",
        element:<SignIn/>,
    },
    {
        path:"*",
        element:<Error404/>,
    },
    {
        path: "/admin",
        element: <Admin_layout />,
        children: [
            {
                path: "/admin/home",
                element: <Dashboard />,
            },
            // {
            //     path: "/admin/blog",
            //     element: <AdminBlog />,
            // },
            // {
            //     path: "/admin/blog-new",
            //     element: <BlogNew />,
            // },
            // {
            //     path: "/admin/gallery",
            //     element: <AdminGallery />,
            // },
            // {
            //     path: "/admin/product",
            //     element: <AdminMedicalProduct />,
            // },
            // {
            //     path: "/admin/video",
            //     element: <AdminVideo />,
            // },
            // {
            //     path: "/admin/reasearchform",
            //     element: <ResearchFaq />,
            // },
            // {
            //     path: "/admin/clinical-learning",
            //     element: <AdminClinicalLearningZone />,
            // },
            // {
            //     path: "/admin/contact-report",
            //     element: <ContactReport />,
            // },
        ],
    },

]
export default Routes;